import {
  alertMessagesArgsConfig,
  browserStorageArgsConfig,
  collectionArgsConfig,
  consoleLogArgsConfig,
  deliveryMethodServicePluginArgsConfig,
  onlyRedirectArgsConfig,
  redirectUrlArgsConfig,
  userRoleArgsConfig,
} from '../../utils/event_constants';

export const loginActionData = [
  {
    name: 'signUpUser',
    label: 'Signup User',
    args: [userRoleArgsConfig({}), ...alertMessagesArgsConfig],
  },
  {
    name: 'signUpUserWithFirebase',
    label: 'Signup with Firebase',
    args: [userRoleArgsConfig({}), ...alertMessagesArgsConfig],
  },
  {
    name: 'signUpUserWithXano',
    label: 'Signup with Xano',
    args: [userRoleArgsConfig({}), ...alertMessagesArgsConfig],
  },
  {
    name: 'loginUser',
    label: 'Login User',
    args: [
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'element',
        label: 'Element',
        type: 'dropdown',
        options: [],
        value: '',
      },
      onlyRedirectArgsConfig,
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'authErrorMessage',
        label: 'Authentication Error Message',
        type: 'text',
        value: 'Username or password does not match. Please try again',
        infoDescription: 'Display Error Message When User or Password is incorrect.',
      },
      {
        name: 'notFoundErrorMessage',
        label: 'User not found Error Message',
        type: 'text',
        value: 'This user does not exists.',
        infoDescription: 'Display Error Message When User does not exist.',
      },
      {
        name: 'othersErrorMessage',
        label: 'Others Error Message',
        type: 'text',
        value: 'Some Internal error. Please contact support.',
        infoDescription: 'Display Error Message when something goes wrong.',
      },
      {
        name: 'registerTwoFactorAuthPage',
        label: 'Select Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
    ],
  },
  {
    name: 'loginUserWithFirebase',
    label: 'Login With Firebase',
    args: [
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'element',
        label: 'Element',
        type: 'dropdown',
        options: [],
        value: '',
      },
      onlyRedirectArgsConfig,
      ,
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'loginUserWithXano',
    label: 'Login With Xano',
    args: [
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'element',
        label: 'Element',
        type: 'dropdown',
        options: [],
        value: '',
      },
      onlyRedirectArgsConfig,
      ,
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'loginUserWithToken',
    label: 'Login User With Token',
    args: [
      {
        minArgCount: 1,
        maxArgCount: 1,
        name: 'element',
        label: 'Select Element',
        type: 'dropdown',
        options: [],
        value: '',
      },
      onlyRedirectArgsConfig,
      ,
    ],
  },
  {
    name: 'logoutUser',
    label: 'Logout User',
    args: [onlyRedirectArgsConfig],
  },
  {
    name: 'forceLogoutUser',
    label: 'Log Out User from All Devices',
    args: [
      {
        name: 'getItemIdFrom',
        label: 'Get Item Id From',
        type: 'dropdown',
        optionsType: 'logoutItemApi',
        value: '',
      },
    ],
  },
  {
    name: 'sendResetPasswordEmail',
    label: 'Send Password Reset Email',
    args: [
      {
        name: 'page',
        label: 'Select Page',
        type: 'dropdown',
        optionsType: 'refreshPageApi',
        options: [],
        value: '',
      },
      {
        name: 'pageComponent',
        label: 'Select Form Component',
        type: 'dropdown',
        optionsType: 'resetPassowordPageComponent',
        options: [],
        value: '',
      },
      {
        name: 'sendTo',
        label: 'Select Email Field',
        type: 'dropdown',
        optionsType: 'pageComponent',
        value: '',
      },
      {
        name: 'emailTemplate',
        label: 'Select Email Template',
        type: 'dropdown',
        optionsType: 'emailTemplateApi',
        options: [],
        value: '',
      },
      deliveryMethodServicePluginArgsConfig('email'),
    ],
  },
  {
    name: 'resetNewPassword',
    label: 'Reset new password',
    args: [
      {
        name: 'page',
        label: 'Select Page',
        type: 'dropdown',
        optionsType: 'refreshPageApi',
        options: [],
        value: '',
      },
      {
        name: 'pageComponent',
        label: 'Select Form Component',
        type: 'dropdown',
        optionsType: 'resetPassowordPageComponent',
        options: [],
        value: '',
      },
      {
        name: 'password',
        label: 'Password',
        type: 'dropdown',
        optionsType: 'pageComponent',
        value: '',
      },
      {
        name: 'confirmPassword',
        label: 'Confirm Password',
        type: 'dropdown',
        optionsType: 'pageComponent',
        value: '',
      },
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'signupAndLoginUser',
    label: 'Signup & Login User',
    args: [userRoleArgsConfig({}), onlyRedirectArgsConfig, ...alertMessagesArgsConfig],
  },
  {
    name: 'signupAndLoginAnonymousUser',
    label: 'Signup & Login Anonymous User',
    args: [userRoleArgsConfig({}), onlyRedirectArgsConfig, ...alertMessagesArgsConfig],
  },
  {
    name: 'chnageOldPassword',
    label: 'Change Password',
    args: [],
  },
  {
    name: 'refreshCurrentLoggedInUser',
    label: 'Refresh Current Logged In User',
    args: [],
  },
  {
    name: 'refreshCurrentTenant',
    label: 'Refresh Current Tenant',
    args: [],
  },
  {
    name: 'refreshCurrentUserSettings',
    label: 'Refresh Current User Settings',
    args: [],
  },
  {
    name: 'saveUserWithCollectionReference',
    label: 'Create User along with Collection (Parent)',
    args: [
      collectionArgsConfig,
      {
        name: 'userRefField',
        label: 'User Reference Field',
        type: 'dropdown',
        optionsType: 'collectionRequestApi',
        options: [],
        value: '',
      },
      userRoleArgsConfig({ optionsType: 'collectionRequestApi' }),
      ...alertMessagesArgsConfig,

      {
        name: 'enableLoginUser',
        label: 'Login with recently created user',
        type: 'boolean',
        value: '',
      },
      onlyRedirectArgsConfig,
      ...browserStorageArgsConfig,
      ...consoleLogArgsConfig,
    ],
  },
  {
    name: 'saveUserWithTenantsAndUserSetting',
    label: 'Create User along with Tenant(s) and User Setting',
    args: [
      userRoleArgsConfig({}),
      {
        name: 'createTenant',
        label: 'Create Tenant with User',
        type: 'boolean',
        value: '',
      },
      {
        name: 'createSubTenant',
        label: 'Create Sub Tenant with User',
        type: 'boolean',
        value: '',
      },
      {
        name: 'createUserSetting',
        label: 'Create User Setting with User',
        type: 'boolean',
        value: '',
      },
      ...alertMessagesArgsConfig,

      {
        name: 'enableLoginUser',
        label: 'Login with recently created user',
        type: 'boolean',
        value: '',
      },
      onlyRedirectArgsConfig,
      ...browserStorageArgsConfig,
      ...consoleLogArgsConfig,
    ],
  },
  {
    name: 'loginWithFacebook',
    label: 'Login with Facebook',
    args: [
      {
        name: 'successRedirectRules',
        label: 'Select Success Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'errorRedirectUrl',
        label: 'Select Error Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'signUpWithFacebook',
    label: 'Sign Up with Facebook',
    args: [userRoleArgsConfig({}), ...redirectUrlArgsConfig, ...alertMessagesArgsConfig],
  },
  {
    name: 'loginWithTwitter',
    label: 'Login with Twitter',
    args: [
      {
        name: 'successRedirectRules',
        label: 'Select Success Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'errorRedirectUrl',
        label: 'Select Error Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'signUpWithTwitter',
    label: 'Sign Up with Twitter',
    args: [userRoleArgsConfig({}), ...redirectUrlArgsConfig, ...alertMessagesArgsConfig],
  },
];
